import getObjectKey from 'lib/object/getObjectKey'

export function generateOfferCreditKey(
  toBeCalculatedBusinessCreditItem: App.BusinessTraveller.ToBeCalculatedBusinessCreditItem,
  offer: App.AnyOffer,
): string {
  const creditItemKey = getObjectKey(toBeCalculatedBusinessCreditItem)

  return `${offer.id}__${creditItemKey}`
}

export function generateFlightCreditKey(
  toBeCalculatedBusinessCreditItem: App.BusinessTraveller.ToBeCalculatedBusinessCreditItem,
): string {
  return getObjectKey(toBeCalculatedBusinessCreditItem)
}
